import React from 'react';
import { Copy, Trash2, MoreVertical } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

interface ManualEntryActionMenuProps {
  onDuplicate: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

export const ManualEntryActionMenu: React.FC<ManualEntryActionMenuProps> = ({
  onDuplicate,
  onDelete,
  disabled = false,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 sm:h-8 sm:w-8"
          disabled={disabled}
          title="Actions"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={onDuplicate} disabled={disabled}>
          <Copy className="mr-2 h-4 w-4" />
          Duplicate Row
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={onDelete} 
          disabled={disabled}
          className="text-destructive focus:text-destructive"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          Delete Row
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
